var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgResearchAssistantAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#FAFCFF",
    stroke: "url(#paint0_linear_2075_19600)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85367 21V12.36H12.4237C12.5077 12.36 12.6157 12.364 12.7477 12.372C12.8797 12.376 13.0017 12.388 13.1137 12.408C13.6137 12.484 14.0257 12.65 14.3497 12.906C14.6777 13.162 14.9197 13.486 15.0757 13.878C15.2357 14.266 15.3157 14.698 15.3157 15.174C15.3157 15.878 15.1377 16.484 14.7817 16.992C14.4257 17.496 13.8797 17.808 13.1437 17.928L12.5257 17.982H10.2997V21H8.85367ZM13.8157 21L12.1117 17.484L13.5817 17.16L15.4537 21H13.8157ZM10.2997 16.632H12.3637C12.4437 16.632 12.5337 16.628 12.6337 16.62C12.7337 16.612 12.8257 16.596 12.9097 16.572C13.1497 16.512 13.3377 16.406 13.4737 16.254C13.6137 16.102 13.7117 15.93 13.7677 15.738C13.8277 15.546 13.8577 15.358 13.8577 15.174C13.8577 14.99 13.8277 14.802 13.7677 14.61C13.7117 14.414 13.6137 14.24 13.4737 14.088C13.3377 13.936 13.1497 13.83 12.9097 13.77C12.8257 13.746 12.7337 13.732 12.6337 13.728C12.5337 13.72 12.4437 13.716 12.3637 13.716H10.2997V16.632ZM16.1755 21L18.8995 12.36H21.0175L23.7415 21H22.2535L19.7815 13.248H20.1055L17.6635 21H16.1755ZM17.6935 19.128V17.778H22.2295V19.128H17.6935Z",
    fill: "url(#paint1_linear_2075_19600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2075_19600",
    x1: 32,
    y1: -9.53674e-7,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E72E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2075_19600",
    x1: 16,
    y1: 12.25,
    x2: 6.78003,
    y2: 22.6993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E72E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchAssistantAvatar);
export default __webpack_public_path__ + "static/media/research-assistant-avatar.806c7a6cf78424a4f822d51514b18849.svg";
export { ForwardRef as ReactComponent };